<template>
  <div>
    <!-- Breadcrumb -->
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div>
          <div class="hidden md:flex text-sm text-gray-500">
            <router-link :to="{ name: 'home' }" class="hover:text-primary">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{ name: 'organization', params: { orgId: orgId } }" class="hover:text-primary">Organization</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{ name: 'top_access_points' }" class="hover:text-primary">Top Access Points</router-link>
          </div>
          <div class="text-2xl text-primary font-bold mt-2">Top Access Points</div>
        </div>
      </div>
    </nav>

    <!-- Filters + Export -->
    <div class="pb-4">
      <div class="bg-white border rounded-lg shadow p-4">
        <div class="flex justify-between items-center mb-4">
          <div class="font-semibold text-gray-700 text-lg">{{ title }}</div>

          <!-- Export Button -->
          <button
            @click="exportToCSV"
            class="bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
          >
            ⬇ Export CSV
          </button>
        </div>

        <!-- Table -->
        <div class="overflow-x-auto rounded-lg shadow">
          <table v-if="!loading" class="table-auto w-full border-collapse">
            <thead>
              <tr class="bg-gray-100 text-gray-700 text-sm uppercase tracking-wide">
                <th class="px-4 py-3 text-left">#</th>
                <th class="px-4 py-3 text-left">Access Point</th>
                <th class="px-4 py-3 text-left">MAC Address</th>
                <th class="px-4 py-3 text-left">Connections</th>
                <th class="px-4 py-3 text-left">Bandwidth</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(ap, index) in accessPoints"
                :key="ap.ap_id"
                class="border-t hover:bg-gray-50 transition-colors"
              >
                <td class="px-4 py-3 font-bold">{{ index + 1 }}</td>
                <td class="px-4 py-3 text-primary font-medium">{{ ap.ap_name }}</td>
                <td class="px-4 py-3">{{ ap.ap_mac }}</td>
                <td class="px-4 py-3">{{ ap.connections }}</td>
                <td class="px-4 py-3">{{ ap.formattedBandwidth }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Loading -->
          <div v-else class="py-6 text-center w-full text-gray-600">
            <feather animation="spin" type="loader" size="32" class="mr-2"></feather>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "../../services/graphql.service";
import moment from "moment/moment";

export default {
  name: "ApStatus",
  props: {
    filters: Object
  },
  data() {
    return {
      usageSummary: [],
      loading: false
    }
  },
  mounted() {
    this.loadStats()
  },
  watch: {
    filters: {
      handler: function () {
        this.loadStats();
      },
      deep: true
    }
  },
  methods: {
    loadStats() {
      this.loading = true;
      let v = [];
      this.filters.venues.forEach(function (venue) {
        v.push(venue.id);
      });

      let params =
        (this.filters.venues.length > 0
          ? 'venues:["' + v.join('","') + '"],'
          : '') +
        'startDate: "' +
        moment(this.filters.dateRange.startDate).format("YYYY-MM-DD 00:00:00") +
        '", ' +
        'endDate: "' +
        moment(this.filters.dateRange.endDate).format("YYYY-MM-DD 23:59:59") +
        '", ' +
        ' orderBy: "bandwidth", limit: 5 ';

      GraphQl.sendRequest(
        `{accessPointUsageSummary(${params}){ap_name access_point_mac access_point_id footfall connections formattedBandwidth }}`
      ).then((response) => {
        this.accessPoints = response.accessPointUsageSummary;
        this.usageSummary = response.accessPointUsageSummary;
        this.loading = false;
      });
    },
    exportToCSV() {
      if (!this.usageSummary.length) {
        alert("No data available to export.");
        return;
      }

      const headers = [
        "Mac Address",
        "Name",
        "Footfall",
        "Connections",
        "Bandwidth",
      ];
      const rows = this.usageSummary.map((record) => [
        record.access_point_mac,
        record.ap_name,
        record.footfall,
        record.connections,
        record.formattedBandwidth,
      ]);

      const csvContent = [headers, ...rows]
        .map((e) => e.join(","))
        .join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "top_access_points.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>